module.exports = __webpack_public_path__ + "static/media/basses.1ead189b.mp3";